import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useEffect } from 'react';
import { portalId, refreshToken } from '../../constants/leadinConfig';
import UISpacer from '../UIComponents/UISpacer';
import PreviewForm from './PreviewForm';
import FormSelect from './FormSelect';
import { usePostBackgroundMessage, BackgroudAppContext, useBackgroundAppContext, } from '../../iframe/useBackgroundApp';
import { ProxyMessages } from '../../iframe/integratedMessages';
import LoadingBlock from '../Common/LoadingBlock';
import { getOrCreateBackgroundApp } from '../../utils/backgroundAppUtils';
function FormEdit({ attributes, isSelected, setAttributes, preview = true, origin = 'gutenberg', }) {
    const { formId, formName } = attributes;
    const formSelected = portalId && formId;
    const isBackgroundAppReady = useBackgroundAppContext();
    const monitorFormPreviewRender = usePostBackgroundMessage();
    const handleChange = (selectedForm) => {
        setAttributes({
            portalId,
            formId: selectedForm.value,
            formName: selectedForm.label,
        });
    };
    useEffect(() => {
        monitorFormPreviewRender({
            key: ProxyMessages.TrackFormPreviewRender,
            payload: {
                origin,
            },
        });
    }, [origin]);
    return !isBackgroundAppReady ? (_jsx(LoadingBlock, {})) : (_jsxs(Fragment, { children: [(isSelected || !formSelected) && (_jsx(FormSelect, { formId: formId, formName: formName, handleChange: handleChange, origin: origin })), formSelected && (_jsxs(Fragment, { children: [isSelected && _jsx(UISpacer, {}), preview && _jsx(PreviewForm, { portalId: portalId, formId: formId })] }))] }));
}
export default function FormEditContainer(props) {
    return (_jsx(BackgroudAppContext.Provider, { value: refreshToken && getOrCreateBackgroundApp(refreshToken), children: _jsx(FormEdit, { ...props }) }));
}
